<section class="main-container">
    <!-- Stepper (Sidebar) -->
    <aside class="side-right">
        <app-stepper [steps]="steps" [currentStep]="onboardingStep" [currentSubStep]="onboardingSubStep"></app-stepper>
    </aside>

    <!-- Main Content -->
    <div class="center-container" [ngSwitch]="onboardingStep">

        <app-step1-applicant-details *ngSwitchCase="1" [data]="onboardingForm.applicant"
            (dataChange)="updateFormData('applicant', $event)" (next)="nextStep()" (prev)="prevStep()"
            [onboardingSubStep]="onboardingSubStep" [onboardingStep]="onboardingStep"></app-step1-applicant-details>

        <app-step2-company-details *ngSwitchCase="2" [data]="onboardingForm.company"
            (dataChange)="updateFormData('applicant', $event)" (next)="nextStep()" (prev)="prevStep()"
            [onboardingSubStep]="onboardingSubStep" [onboardingStep]="onboardingStep"></app-step2-company-details>

        <app-step3-business-profile *ngSwitchCase="3" [data]="onboardingForm.profile"
            (dataChange)="updateFormData('applicant', $event)" (next)="nextStep()" (prev)="prevStep()"
            [onboardingSubStep]="onboardingSubStep" [onboardingStep]="onboardingStep"></app-step3-business-profile>
    </div>
</section>

